var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-select',{attrs:{"placeholder":_vm.$props.placeholder},on:{"change":_vm.handleChange}},_vm._l((_vm.data),function(item){return _c('a-select-option',{key:item.id,attrs:{"value":item.id}},[_vm._v(" "+_vm._s(item.displayname)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }